import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectSingularUGCByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'privateNotesTransactions'], Immutable.Map());

export const selectPrivateNotesByUsers = selectSingularUGCByUsers('privateNotes');

export const selectPrivateNotesTransactions = createSelector([getTransactions], transactions => transactions);

export default {
  selectPrivateNotesByUsers,
  selectPrivateNotesTransactions
};
